// tiss-unimed/TissGlosas.js
// Tabela 38 do Padrao TISS - Mensagens (Glosas, Negativas e Outras)
// Fonte: Tabelas de Dominio do Padrao TISS v4.02.00 (ANS). Texto oficial, nao parafraseado.
// Gerado a partir do PDF oficial - nao editar a mao: se a ANS publicar nova versao, regerar.

export const GLOSAS_TISS = {
  '1001': 'NÚMERO DA CARTEIRA INVÁLIDO',
  '1002': 'NÚMERO DO CARTÃO NACIONAL DE SAÚDE INVÁLIDO',
  '1003': 'A ADMISSÃO DO BENEFICIÁRIO NO PRESTADOR OCORREU ANTES DA INCLUSÃO DO BENEFICIÁRIO NA OPERADORA',
  '1004': 'SOLICITAÇÃO ANTERIOR À INCLUSÃO DO BENEFICIÁRIO',
  '1005': 'ATENDIMENTO ANTERIOR À INCLUSÃO DO BENEFICIÁRIO',
  '1006': 'ATENDIMENTO APÓS O DESLIGAMENTO DO BENEFICIÁRIO',
  '1007': 'ATENDIMENTO DENTRO DA CARÊNCIA DO BENEFICIÁRIO',
  '1008': 'ASSINATURA DIVERGENTE',
  '1009': 'BENEFICIÁRIO COM PAGAMENTO EM ABERTO',
  '1010': 'ASSINATURA DO TITULAR / RESPONSÁVEL INEXISTENTE',
  '1011': 'IDENTIFICAÇÃO DO BENEFICIÁRIO NÃO CONSISTENTE',
  '1012': 'SERVIÇO PROFISSIONAL HOSPITALAR NÃO É COBERTO PELO PLANO DO BENEFICIÁRIO',
  '1013': 'CADASTRO DO BENEFICIÁRIO COM PROBLEMAS',
  '1014': 'BENEFICIÁRIO COM DATA DE EXCLUSÃO',
  '1015': 'IDADE DO BENEFICIÁRIO ACIMA IDADE LIMITE',
  '1016': 'BENEFICIÁRIO COM ATENDIMENTO SUSPENSO',
  '1017': 'DATA VALIDADE DA CARTEIRA VENCIDA',
  '1018': 'EMPRESA DO BENEFICIÁRIO SUSPENSA / EXCLUÍDA',
  '1019': 'FAMÍLIA DO BENEFICIÁRIO COM ATENDIMENTO SUSPENSO',
  '1020': 'VIA DE CARTÃO DO BENEFICIÁRIO CANCELADA',
  '1021': 'VIA DE CARTÃO DO BENEFICIÁRIO NÃO LIBERADA',
  '1022': 'VIA DE CARTÃO DO BENEFICIÁRIO NÃO COMPATÍVEL',
  '1023': 'NOME DO TITULAR INVÁLIDO',
  '1024': 'PLANO NÃO EXISTENTE',
  '1025': 'BENEFICIÁRIO NÃO POSSUI COBERTURA PARA ASSISTÊNCIA ODONTOLÓGICA',
  '1101': 'QUANTIDADE DE GUIAS INFORMADAS NO PROTOCOLO DIFERENTE DAS CADASTRADAS',
  '1102': 'PROTOCOLO É DE RE-APRESENTAÇÃO',
  '1103': 'PROTOCOLO NÃO É DE REAPRESENTAÇÃO',
  '1104': 'VALOR TOTAL DO PROTOCOLO DIFERENTE DO VALOR TOTAL DAS GUIAS',
  '1201': 'ATENDIMENTO FORA DA VIGÊNCIA DO CONTRATO COM O CREDENCIADO',
  '1202': 'NÚMERO DO CNES INVÁLIDO',
  '1203': 'CÓDIGO PRESTADOR INVÁLIDO',
  '1204': 'ADMISSÃO ANTERIOR À INCLUSÃO DO CREDENCIADO NA REDE',
  '1205': 'ADMISSÃO APÓS O DESLIGAMENTO DO CREDENCIADO DA REDE',
  '1206': 'CPF / CNPJ INVÁLIDO',
  '1207': 'CREDENCIADO NÃO PERTENCE À REDE CREDENCIADA',
  '1208': 'SOLICITAÇÃO ANTERIOR À INCLUSÃO DO CREDENCIADO',
  '1209': 'SOLICITAÇÃO APÓS O DESLIGAMENTO DO CREDENCIADO',
  '1210': 'SOLICITANTE CREDENCIADO NÃO CADASTRADO',
  '1211': 'ASSINATURA / CARIMBO DO CREDENCIADO INEXISTENTE',
  '1212': 'ATENDIMENTO / REFERÊNCIA FORA DA VIGÊNCIA DO CONTRATO DO PRESTADOR',
  '1213': 'CBO (ESPECIALIDADE) INVÁLIDO',
  '1214': 'CREDENCIADO NÃO HABILITADO A REALIZAR O PROCEDIMENTO',
  '1215': 'CREDENCIADO FORA DA ABRANGÊNCIA GEOGRÁFICA DO PLANO',
  '1216': 'ESPECIALIDADE NÃO CADASTRADA',
  '1217': 'ESPECIALIDADE NÃO CADASTRADA PARA O PRESTADOR',
  '1218': 'CÓDIGO DE PRESTADOR INCOMPATIVEL COM PROCEDIMENTO / EXAME COBRADO',
  '1301': 'TIPO GUIA INVÁLIDO',
  '1302': 'CÓDIGO TIPO GUIA PRINCIPAL E NÚMERO GUIAS INCOMPATÍVEIS',
  '1303': 'NÃO EXISTE O NÚMERO GUIA PRINCIPAL INFORMADO',
  '1304': 'COBRANÇA EM GUIA INDEVIDA',
  '1305': 'ITEM PAGO EM OUTRA GUIA',
  '1306': 'NÃO EXISTE NÚMERO GUIA PRINCIPAL E/OU CÓDIGO GUIA PRINCIPAL',
  '1307': 'NÚMERO DA GUIA INVÁLIDO',
  '1308': 'GUIA JÁ APRESENTADA',
  '1309': 'PROCEDIMENTO CONTRATADO NÃO ESTÁ DE ACORDO COM O TIPO DE GUIA UTILIZADO',
  '1310': 'SERVIÇO DO TIPO CIRÚRGICO E INVASIVO EQUIPE MÉDICA NÃO INFORMADA NA GUIA',
  '1311': 'PRESTADOR EXECUTANTE NÃO INFORMADO',
  '1312': 'PRESTADOR CONTRATADO NÃO INFORMADO',
  '1313': 'GUIA COM RASURA',
  '1314': 'GUIA SEM ASSINATURA E/OU CARIMBO DO CREDENCIADO',
  '1315': 'GUIA SEM DATA DO ATO CIRÚRGICO',
  '1316': 'GUIA COM LOCAL DE ATENDIMENTO PREENCHIDO INCORRETAMENTE',
  '1317': 'GUIA SEM DATA DO ATENDIMENTO',
  '1318': 'GUIA COM CÓDIGO DE SERVIÇO PREENCHIDO INCORRETAMENTE',
  '1319': 'GUIA SEM ASSINATURA DO ASSISTIDO',
  '1320': 'IDENTIFICAÇÃO DO ASSISTIDO INCOMPLETA',
  '1321': 'VALIDADE DA GUIA EXPIRADA',
  '1322': 'COMPROVANTE PRESENCIAL OU GTO NÃO ENVIADO',
  '1323': 'DATA PREENCHIDA INCORRETAMENTE',
  '1401': 'ACOMODAÇÃO NÃO AUTORIZADA',
  '1402': 'PROCEDIMENTO NÃO AUTORIZADO',
  '1403': 'NÃO EXISTE INFORMAÇÃO SOBRE A SENHA DE AUTORIZAÇÃO DO PROCEDIMENTO',
  '1404': 'NÃO EXISTE GUIA DE AUTORIZAÇÃO RELACIONADA',
  '1405': 'DATA DE VALIDADE DA SENHA É ANTERIOR A DATA DO ATENDIMENTO',
  '1406': 'NÚMERO DA SENHA INFORMADO DIFERENTE DO LIBERADO',
  '1407': 'SERVIÇO SOLICITADO NÃO POSSUI COBERTURA',
  '1408': 'QUANTIDADE SERVIÇO SOLICITADA ACIMA DA AUTORIZADA',
  '1409': 'QUANTIDADE SERVIÇO SOLICITADA ACIMA COBERTA',
  '1410': 'SERVIÇO SOLICITADO EM CARÊNCIA',
  '1411': 'SOLICITANTE NÃO INFORMADO',
  '1412': 'PROBLEMAS NO SISTEMA AUTORIZADOR',
  '1413': 'ACOMODAÇÃO NÃO POSSUI COBERTURA',
  '1414': 'DATA DE VALIDADE DA SENHA EXPIRADA',
  '1415': 'PROCEDIMENTO NÃO AUTORIZADO PARA O BENEFICIÁRIO',
  '1416': 'SOLICITANTE NÃO CADASTRADO',
  '1417': 'SOLICITANTE NÃO HABILITADO',
  '1418': 'SOLICITANTE SUSPENSO',
  '1419': 'SERVIÇO SOLICITADO JÁ AUTORIZADO',
  '1420': 'SERVIÇO SOLICITADO FORA DA COBERTURA',
  '1421': 'SERVIÇO SOLICITADO É DE PRÉ-EXISTÊNCIA',
  '1422': 'ESPECIALIDADE NÃO CADASTRADA PARA O SOLICITANTE',
  '1423': 'QUANTIDADE SOLICITADA ACIMA DA QUANTIDADE PERMITIDA',
  '1424': 'QUANTIDADE AUTORIZADA ACIMA DA QUANTIDADE PERMITIDA',
  '1425': 'NECESSITA PRÉ-AUTORIZAÇÃO DA EMPRESA',
  '1426': 'NÃO AUTORIZADO PELA AUDITORIA',
  '1427': 'NECESSIDADE DE AUDITORIA MÉDICA',
  '1428': 'FALTA DE AUTORIZAÇÃO DA EMPRESA DE CONECTIVIDADE',
  '1429': 'CBO-S (ESPECIALIDADE) NÃO AUTORIZADO A REALIZAR O SERVIÇO',
  '1430': 'PROCEDIMENTO ODONTOLÓGICO NÃO AUTORIZADO',
  '1431': 'PROCEDIMENTO NÃO AUTORIZADO NA FACE SOLICITADA',
  '1432': 'PROCEDIMENTO NÃO AUTORIZADO PARA DENTE/REGIÃO SOLICITADA',
  '1433': 'PROCEDIMENTO NÃO AUTORIZADO, DENTE AUSENTE',
  '1434': 'COBRANÇA DE CONTA DE CTI NEONATAL NA SENHA DO PARTO',
  '1435': 'VIGÊNCIA DO ACORDO POSTERIOR À DATA DE REALIZAÇÃO DO PROCEDIMENTO',
  '1436': 'CANCELAMENTO DO ACORDO ANTERIOR À DATA DE REALIZAÇÃO DO PROCEDIMENTO',
  '1437': 'SENHA DE AUTORIZAÇÃO CANCELADA',
  '1438': 'ATENDER A DIRETRIZ DE UTILIZAÇÃO (DUT) DO ROL DE',
  '1501': 'TEMPO DE EVOLUÇÃO DA DOENÇA INVÁLIDO',
  '1502': 'TIPO DE DOENÇA INVÁLIDO',
  '1503': 'INDICADOR DE ACIDENTE INVÁLIDO',
  '1504': 'CARÁTER DE INTERNAÇÃO INVÁLIDO',
  '1505': 'REGIME DA INTERNAÇÃO INVÁLIDO',
  '1506': 'TIPO DE INTERNAÇÃO INVÁLIDO',
  '1507': 'URGÊNCIA/EMERGÊNCIA NÃO APLICÁVEL',
  '1508': 'CÓDIGO CID NÃO INFORMADO',
  '1509': 'CÓDIGO CID INVÁLIDO',
  '1601': 'REINCIDÊNCIA NO ATENDIMENTO',
  '1602': 'TIPO DE ATENDIMENTO INVÁLIDO OU NÃO INFORMADO',
  '1603': 'TIPO DE CONSULTA INVÁLIDO',
  '1604': 'TIPO DE SAÍDA INVÁLIDO',
  '1605': 'INTERVENÇÃO ANTERIOR A ADMISSÃO',
  '1606': 'FINAL DA INTERVENÇÃO ANTERIOR AO INÍCIO DA INTERVENÇÃO',
  '1607': 'ALTA HOSPITALAR ANTERIOR AO FINAL DA INTERVENÇÃO',
  '1608': 'ALTA ANTERIOR À DATA DE INTERNAÇÃO',
  '1609': 'MOTIVO SAÍDA INVÁLIDO',
  '1610': 'ÓBITO MULHER INVÁLIDO',
  '1611': 'INTERVENÇÃO ANTERIOR A INTERNAÇÃO',
  '1612': 'SERVIÇO NÃO PODE SER REALIZADO NO LOCAL ESPECIFICADO',
  '1613': 'CONSULTA NÃO AUTORIZADA',
  '1614': 'SERVIÇO AMBULATORIAL NÃO AUTORIZADO',
  '1615': 'INTERNAÇÃO NÃO AUTORIZADA',
  '1701': 'COBRANÇA FORA DO PRAZO DE VALIDADE',
  '1702': 'COBRANÇA DE PROCEDIMENTO EM DUPLICIDADE',
  '1703': 'HORÁRIO DO ATENDIMENTO NÃO ESTÁ NA FAIXA DE URGÊNCIA/EMERGÊNCIA',
  '1704': 'VALOR COBRADO SUPERIOR AO ACORDADO EM PACOTE',
  '1705': 'VALOR APRESENTADO A MAIOR',
  '1706': 'VALOR APRESENTADO A MENOR',
  '1707': 'NÃO EXISTE INFORMAÇÃO SOBRE A TABELA QUE SERÁ UTILIZADA NA VALORAÇÃO VERIFIQUE O CONTRATO DO PRESTADOR',
  '1708': 'NÃO EXISTE VALOR PARA O PROCEDIMENTO REALIZADO',
  '1709': 'FALTA PRESCRIÇÃO MÉDICA',
  '1710': 'FALTA VISTO DA ENFERMAGEM',
  '1711': 'PROCEDIMENTO PERTENCE A UM PACOTE ACORDADO E JÁ COBRADO',
  '1712': 'ASSINATURA DO MÉDICO RESPONSÁVEL PELO EXAME INEXISTENTE',
  '1713': 'FATURAMENTO INVÁLIDO',
  '1714': 'VALOR DO SERVIÇO SUPERIOR AO VALOR DE TABELA',
  '1715': 'VALOR DO SERVIÇO INFERIOR AO VALOR DE TABELA',
  '1716': 'PERCENTUAL DE REDUÇÃO/ACRÉSCIMO FORA DOS VALORES DEFINIDOS EM TABELA',
  '1717': 'PAGO CONFORME RELATÓRIO DE AUDITORIA EXTERNA - CONTA INICIAL',
  '1718': 'REANÁLISE NEGADA, PAGO CONFORME RELATÓRIO AUDITORIA',
  '1719': 'REANÁLISE NEGADA, ANÁLISE CONFORME TABELA ACORDADA',
  '1720': 'LIBERADOS 150% DE VÍDEO, SEM COBERTURA PARA ADICIONAL DE ACOMODAÇÃO',
  '1721': 'CÓDIGO COBRADO SUBSTITUÍDO PELO CÓDIGO PAGO',
  '1722': 'PAGO CONFORME NEGOCIAÇÃO',
  '1723': 'ADICIONAL DE URGÊNCIA NÃO PREVISTO PARA ATENDIMENTO CLÍNICO',
  '1724': 'PERÍODO DE 10 DIAS APÓS REALIZAÇÃO DO PROCEDIMENTO',
  '1725': 'VALOR PAGO A MAIOR REFERENTE À TAXA ADMINISTRATIVA',
  '1726': 'VALOR APRESENTADO A MAIOR - PLANO INDIVIDUAL',
  '1727': 'PAGO VALOR COMPATIVEL COM O PROCEDIMENTO',
  '1728': 'COBRANÇA DE MATERIAL INCLUSO NO PROCEDIMENTO / EXAME REALIZADO',
  '1729': 'COBRANÇA DE MATERIAL COM VALOR ACIMA DO PERMITIDO PARA PROCEDIMENTO/EXAME REALIZADO',
  '1730': 'FILME INCLUSO NO EXAME REALIZADO',
  '1731': 'TAXA INCOMPATIVEL PARA ATENDIMENTO AMBULATORIAL',
  '1732': 'QT COM DATA DE EVENTO DIVERGENTE DA LIBERADA',
  '1733': 'RECUPERAÇÃO DE VALORES POR PAGAMENTO INDEVIDO',
  '1734': 'COBRADO CONTA ABERTA, PAGO O PACOTE CONFORME NEGOCIAÇÃO',
  '1735': 'COBRANÇA DE PACOTE NÃO NEGOCIADO COM O PRESTADOR',
  '1736': 'CONTA AGUARDANDO NEGOCIAÇÃO PARA PAGAMENTO',
  '1737': 'DIFERENÇA DEVE SER COBRADA DO BENEFICIÁRIO PELO PRESTADOR COMO FRANQUIA',
  '1738': 'DOCUMENTO FISCAL NÃO ENVIADO',
  '1739': 'DUPLICIDADE DE CONTA DEVIDO A PERIODO COBRADO JÁ EFETUADO EM OUTRA PARCIAL',
  '1740': 'ESTORNO DO VALOR DE PROCEDIMENTO PAGO',
  '1741': 'HONORÁRIO OU PROCEDIMENTO JÁ PAGO A OUTRO PRESTADOR',
  '1742': 'HONORÁRIO OU PROCEDIMENTO JÁ PAGO POR REEMBOLSO AO BENEFICIÁRIO',
  '1743': 'NÃO HÁ NEGOCIAÇÃO PARA COBRANÇA DO KIT, DISCRIMINAR POR ITENS',
  '1744': 'NEGOCIAÇÃO DIFERENCIADA DEVIDO A LIMINAR',
  '1745': 'PAGAMENTO DA EQUIPE CONFORME RELATÓRIO DO CIRURGIÃO',
  '1746': 'PERCENTUAL DE ACRÉSCIMO DIFERENTE DO NEGOCIADO',
  '1747': 'PLANO DO BENEFICIÁRIO E O TIPO DE ACOMODAÇÃO NÃO PERMITEM ACRÉSCIMO DE HONORÁRIOS',
  '1748': 'PROCEDIMENTO NÃO CARACTERIZA URGÊNCIA/EMÊRGENCIA',
  '1749': 'RELATÓRIO DE AUDITORIA NÃO ENVIADO NA CONTA',
  '1801': 'PROCEDIMENTO INVÁLIDO',
  '1802': 'PROCEDIMENTO INCOMPATÍVEL COM O SEXO DO BENEFICIÁRIO',
  '1803': 'IDADE DO BENEFICIÁRIO INCOMPATÍVEL COM O PROCEDIMENTO',
  '1804': 'NÚMERO DE DIAS LIBERADOS / SESSÕES AUTORIZADAS NÃO INFORMADAS',
  '1805': 'VALOR TOTAL DO PROCEDIMENTO DIFERENTE DO VALOR PROCESSADO',
  '1806': 'QUANTIDADE DE PROCEDIMENTO DEVE SER MAIOR QUE ZERO',
  '1807': 'PROCEDIMENTOS MÉDICOS DUPLICADOS',
  '1808': 'PROCEDIMENTO NÃO CONFORME COM CID',
  '1809': 'COBRANÇA DE PROCEDIMENTO NÃO EXECUTADO',
  '1810': 'COBRANÇA DE PROCEDIMENTO NÃO SOLICITADO PELO MÉDICO',
  '1811': 'PROCEDIMENTO SEM REGISTRO DE EXECUÇÃO',
  '1812': 'COBRANÇA DE PROCEDIMENTO NÃO CORRELACIONADO AO RELATÓRIO ESPECÍFICO',
  '1813': 'COBRANÇA DE PROCEDIMENTO SEM JUSTIFICATIVA PARA REALIZAÇÃO OU COM JUSTIFICATIVA INSUFICIENTE',
  '1814': 'COBRANÇA DE PROCEDIMENTO COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '1816': 'COBRANÇA DE PROCEDIMENTO EM QUANTIDADE INCOMPATÍVEL COM O PROCEDIMENTO/EVOLUÇÃO CLÍNICA',
  '1817': 'COBRANÇA DE PROCEDIMENTO INCLUSO NO PROCEDIMENTO PRINCIPAL',
  '1818': 'COBRANÇA DE PROCEDIMENTO QUE EXIGE AUTORIZAÇÃO PRÉVIA',
  '1819': 'COBRANÇA DE PROCEDIMENTO COM HISTÓRIA CLÍNICA/HIPÓTESE DIAGNÓSTICA NÃO COMPATÍVEL',
  '1820': 'COBRANÇA DE PROCEDIMENTO EM QUANTIDADE ACIMA DA MÁXIMA PERMITIDA/AUTORIZADA',
  '1821': 'COBRANÇA DE PROCEDIMENTO NÃO COMPATÍVEL COM A IDADE',
  '1822': 'COBRANÇA DE PROCEDIMENTO COM AUSÊNCIA DE RESULTADO OU LAUDO TÉCNICO',
  '1823': 'MESMA ESPECIALIDADE, NO PRAZO INFERIOR AO ESTIPULADO',
  '1824': 'PROCEDIMENTO COBRADO NÃO CORRESPONDE AO EXAME EXECUTADO',
  '1825': 'COBRANÇA DE PROCEDIMENTO AMBULATORIAL COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '1826': 'VIAS DE ACESSO DOS PROCEDIMENTOS COBRADOS NÃO ESTÃO PREVISTAS NA LISTAGEM DE PROCEDIMENTOS MÚLTIPLOS',
  '1827': 'MESMA DATA, PELO MESMO PROFISSIONAL COM MESMO GRAU DE PARTICIPAÇÃO - LIBERADO VALOR REFERENTE À VIA DE',
  '1828': 'ADICIONAL DE URGÊNCIA NÃO PREVISTO PARA PROCEDIMENTO CIRÚRGICO ELETIVO',
  '1829': 'ADICIONAL DE VÍDEO NÃO PREVISTO PARA O PROCEDIMENTO',
  '1830': 'DE ATENDIMENTO-VISITA, PLANTÃO, INTENSIVISTA, AVALIAÇÃO',
  '1831': 'LAUDO DO EXAME ENVIADO NÃO JUSTIFICA A COBRANÇA DO PROCEDIMENTO',
  '1832': 'PROCEDIMENTO NÃO PERMITE COBRANÇA DE AUXILIAR DE ANESTESISTA',
  '1833': 'PROCEDIMENTO COBRADO NÃO PERMITE ACRÉSCIMO DE ACOMODAÇÃO',
  '1834': 'PORTE ANESTÉSICO COBRADO INCOMPATÍVEL COM O PORTE DO PROCEDIMENTO REALIZADO',
  '1835': 'RELATÓRIO MÉDICO, PARA O PROCEDIMENTO REALIZADO E/OU',
  '1836': 'DE ADMINISTRAÇÃO DO MEDICAMENTO - VO OU IV PERIFÉRICA -',
  '1837': 'NÃO CABE PAGAMENTO DO HONORÁRIO INTEGRAL POR SER VIA DE ACESSO CIRÚRGICO DIFERENTE',
  '1838': 'GRAU DE PARTICIPAÇÃO INFORMADO INCOMPATÍVEL COM EVENTO COBRADO',
  '1839': 'NECESSÁRIO ENVIO DO RESULTADO DO EXAME ANÁTOMO PATOLÓGICO',
  '1840': 'PROCEDIMENTO EXECUTADO ANTES DA AUTORIZAÇÃO',
  '1901': 'ACOMODAÇÃO INVÁLIDA',
  '1902': 'ACOMODAÇÃO INFORMADA NÃO ESTÁ DE ACORDO COM ACOMODAÇÃO CONTRATADA',
  '1903': 'PERMANÊNCIA HOSPITALAR INCOMPATÍVEL COM A EVOLUÇÃO CLÍNICA',
  '1904': 'PERMANÊNCIA HOSPITALAR INCOMPATÍVEL COM O PROCEDIMENTO AUTORIZADO',
  '1905': 'QUANTIDADE DE DIÁRIAS DEVE SER MAIOR QUE ZERO',
  '1906': 'ACOMODAÇÃO NÃO INFORMADA',
  '1907': 'QUANTIDADE UTI NÃO PREVISTA PARA PROCEDIMENTO',
  '1908': 'USUÁRIO NÃO POSSUI COBERTURA DE UTI',
  '1910': 'COBRANÇA DE DIÁRIAS EM LOCAIS DE ACOMODAÇÕES DIFERENTES, NO MESMO DIA',
  '1911': 'PERMANÊNCIA HOSPITALAR PARA INVESTIGAÇÃO INJUSTIFICADA',
  '1912': 'EVOLUÇÃO CLÍNICA NÃO COMPATÍVEL COM A PERMANÊNCIA EM UTI',
  '1913': 'CÓDIGO DE DIÁRIA INCOMPATÍVEL COM O LOCAL DE ATENDIMENTO',
  '1914': 'COBRANÇA DE DIÁRIA EM QUANTIDADE INCOMPATÍVEL COM A PERMANÊNCIA HOSPITALAR',
  '1915': 'MUDANÇA DE ACOMODAÇÃO SEM COMUNICAÇÃO AO PACIENTE, FAMILIAR OU ACOMPANHANTE, OU SEM SOLICITAÇÃO DESTES',
  '1916': 'COBRANÇA DE DIÁRIAS DE UTI INCOMPATÍVEL COM DIAGNÓSTICO E EVOLUÇÃO CLÍNICA',
  '1917': 'FALTA PRORROGAÇÃO PARA QUANTIDADE DE DIÁRIAS COBRADAS',
  '1918': 'PLANO DO BENEFICIÁRIO NÃO CONTEMPLA DIÁRIA DE ACOMPANHANTE',
  '2001': 'MATERIAL INVÁLIDO',
  '2002': 'MATERIAL SEM COBERTURA PARA ATENDIMENTO AMBULATORIAL',
  '2003': 'MATERIAL NÃO ESPECIFICADO',
  '2004': 'MATERIAL SEM NOTA FISCAL DO FORNECEDOR',
  '2005': 'QUANTIDADE DE MATERIAL DEVE SER MAIOR QUE ZERO',
  '2006': 'MATERIAL INFORMADO NÃO COBERTO',
  '2007': 'COBRANÇA DE MATERIAL EM QUANTIDADE INCOMPATÍVEL COM A PERMANÊNCIA',
  '2008': 'COBRANÇA DE MATERIAL EM QUANTIDADES INCOMPATÍVEIS COM O PROCEDIMENTO REALIZADO',
  '2009': 'QUANTIDADE DE MATERIAL SUPERIOR A QUANTIDADE COBERTA',
  '2010': 'COBRANÇA DE MATERIAIS INCLUSOS NAS TAXAS',
  '2011': 'COBRANÇA DE MATERIAL INCLUSO NO PACOTE NEGOCIADO',
  '2012': 'COBRANÇA DE MATERIAL INCOMPATÍVEL COM O RELATÓRIO TÉCNICO',
  '2013': 'COBRANÇA DE MATERIAL EM PERMANÊNCIA HOSPITALAR NÃO AUTORIZADA',
  '2014': 'COBRANÇA DE MATERIAL NÃO UTILIZADO',
  '2015': 'MATERIAL NÃO AUTORIZADO',
  '2101': 'MEDICAMENTO INVÁLIDO',
  '2102': 'MEDICAMENTO SEM COBERTURA PARA ATENDIMENTO AMBULATORIAL',
  '2103': 'MEDICAMENTO NÃO ESPECIFICADO',
  '2104': 'MEDICAMENTO SEM NOTA FISCAL DO FORNECEDOR',
  '2105': 'QUANTIDADE DE MEDICAMENTOS DEVE SER MAIOR QUE ZERO',
  '2106': 'MEDICAMENTO INFORMADO NÃO COBERTO',
  '2107': 'COBRANÇA DE MEDICAMENTO EM QUANTIDADE INCOMPATÍVEL COM A PERMANÊNCIA',
  '2108': 'COBRANÇA DE MEDICAMENTO EM QUANTIDADES INCOMPATÍVEIS COM O PROCEDIMENTO REALIZADO',
  '2109': 'QUANTIDADE DE MEDICAMENTO SUPERIOR A QUANTIDADE COBERTA',
  '2110': 'COBRANÇA DE MEDICAMENTO INCLUSOS NAS TAXAS',
  '2111': 'COBRANÇA DE MEDICAMENTO INCLUSO NO PACOTE NEGOCIADO',
  '2112': 'COBRANÇA DE MEDICAMENTO INCOMPATÍVEL COM O RELATÓRIO TÉCNICO',
  '2113': 'COBRANÇA DE MEDICAMENTO EM PERMANÊNCIA HOSPITALAR NÃO AUTORIZADA',
  '2114': 'COBRANÇA DE MEDICAMENTO NÃO UTILIZADO',
  '2115': 'MEDICAMENTO NÃO AUTORIZADO',
  '2201': 'OPME INVÁLIDO',
  '2202': 'OPME SEM COBERTURA PARA ATENDIMENTO AMBULATORIAL',
  '2203': 'OPME SEM NOTA FISCAL DO FORNECEDOR',
  '2204': 'QUANTIDADE DE OPME DEVE SER MAIOR QUE ZERO',
  '2205': 'OPME INFORMADO NÃO COBERTO',
  '2206': 'OPME INFORMADO NÃO AUTORIZADO',
  '2207': 'COBRANÇA DE OPME NÃO UTILIZADO',
  '2208': 'COBRANÇA DE OPME NO ITEM MATERIAL E MEDICAMENTOS',
  '2209': 'COBRANÇA DE OPME EM DESACORDO COM RELATÓRIO TÉCNICO',
  '2210': 'COBRANÇA DE OPME EM QUANTIDADE INCOMPATÍVEL COM O PROCEDIMENTO REALIZADO',
  '2211': 'COBRANÇA DE OPME INCLUSA NO PACOTE NEGOCIADO',
  '2212': 'OPME EM DESACORDO COM OS CRITÉRIOS TÉCNICOS ADOTADOS PELA OPERADORA',
  '2213': 'OPME PAGO A FORNECEDOR TERCEIRIZADO',
  '2301': 'GASES MEDICINAIS INVÁLIDOS',
  '2302': 'COBRANÇA DE OXIGENOTERAPIA SEM PRESCRIÇÃO MÉDICA',
  '2303': 'COBRANÇA DE OXIGENOTERAPIA COM QUANTITATIVO DE USO EM DIVERGÊNCIA/PAGO VALOR CORRIGIDO',
  '2304': 'COBRANÇA DE OXIGÊNIO INCLUSO NA TAXA DE NEBULIZAÇÃO ESPECIFICADA',
  '2305': 'COBRANÇA DE OXIGENOTERAPIA EM USO PROLONGADO SEM JUSTIFICATIVA DE USO',
  '2306': 'COBRANÇA DE OXIGENOTERAPIA SEM REGISTRO DE CONTROLE DE USO (ENTRADA E SAÍDA)',
  '2307': 'COBRANÇA DE GASES EM QUANTIDADE SUPERIOR AO PERÍODO DE PERMANÊNCIA',
  '2308': 'DURANTE TODA A REALIZAÇÃO DO PROCEDIMENTO (INÍCIO AO',
  '2309': 'COBRANÇA DE AR COMPRIMIDO SEM REGISTRO NO BOLETIM ANESTÉSICO E DURAÇÃO DE USO',
  '2310': 'COBRANÇA DE GASES INCOMPATÍVEL COM O UTILIZADO/ PRESCRITO',
  '2401': 'TAXA / ALUGUEL INVÁLIDO',
  '2402': 'COM O PROCEDIMENTO REALIZADO/USO PREVISTO NO',
  '2403': 'COBRANÇA DE TAXA DE USO DE BOMBA DE INFUSÃO EM PACIENTE INTERNADO NA UTI',
  '2404': 'COBRANÇA DE OUTRAS TAXAS ASSOCIADAS/INCLUSAS NA COBRANÇA DA TAXA DE SALA PREVISTA',
  '2405': 'CONTA DO NÚMERO DE PROCEDIMENTOS REALIZADOS NO',
  '2406': 'COBRANÇA INDEVIDA DE TAXA DE SALA POR ADMINISTRAÇÃO DE MEDICAMENTOS',
  '2407': 'COBRANÇA DE TAXAS, DE SERVIÇOS REALIZADOS EM AMBIENTES INCOMPATÍVEIS COM O USO DE EQUIPAMENTOS',
  '2408': 'COBRANÇA DE TAXAS EM QUANTIDADE SUPERIOR AO TEMPO DE PERMANÊNCIA HOSPITALAR',
  '2409': 'COBRANÇA DE TAXA DE OBSERVAÇÃO EM PRONTO SOCORRO COM PERMANÊNCIA MENOR QUE O PERÍODO ESTIPULADO',
  '2410': 'COBRANÇA DE TAXA DE OBSERVAÇÃO EM PRONTO SOCORRO SEM O REGISTRO DA PERMANÊNCIA',
  '2411': 'COBRANÇA DE TAXA DE SALA DE PRONTO SOCORRO, PARA APLICAÇÃO DE MEDICAMENTOS',
  '2412': 'COBRANÇA DE TAXA DE RECUPERAÇÃO ANESTÉSICA NÃO JUSTIFICADA PARA O PROCEDIMENTO',
  '2413': 'COBRANÇA DE TAXA INCLUSA NO PACOTE NEGOCIADO',
  '2414': 'COBRANÇA DE TAXA DE EQUIPAMENTO EM CONCOMITÂNCIA COM A COBRANÇA DE TAXA PARA O PROCEDIMENTO',
  '2415': 'TAXA EXIGE INFORMAÇÃO DO VALOR NA GUIA',
  '2416': 'PACIENTES COM PÓS-OPERATÓRIO IMEDIATO REALIZADO NA',
  '2417': 'COBRANÇA DE TAXA DE RECUPERAÇÃO ANESTÉSICA SEM A PRESENÇA DO ANESTESISTA',
  '2418': 'COBRANÇA DE TAXA DE SALA INCOMPATÍVEL COM O PROCEDIMENTO',
  '2419': 'COBRANÇA DE TAXA DE OBSERVAÇÃO PARA ATENDIMENTO QUE GEROU UMA INTERNAÇÃO',
  '2420': 'ANESTÉSICO DIFERENTE DO PROCEDIMENTO',
  '2421': 'COBRANÇA DE TAXA EM QUANTIDADE INCORRETA',
  '2422': 'OBRIGATÓRIO NA SALA DE CIRURGIA, CUJA TAXA DE SALA',
  '2423': 'COBRANÇA DE TAXA DE EQUIPAMENTOS DE USO OBRIGATÓRIO NO LOCAL DE ATENDIMENTO',
  '2501': 'PROCEDIMENTO EM SÉRIE INVÁLIDO',
  '2502': 'COBRANÇA DE DUAS AVALIAÇÕES FISIOTERÁPICAS',
  '2503': 'COBRANÇA DE PSICOTERAPIA INDIVIDUAL, QUANDO O APLICADO É A COBRANÇA DE PSICOTERAPIA EM GRUPO',
  '2504': 'QUANTIDADE DE SESSÕES COBRADAS NÃO CONDIZEM COM AS ASSINATURAS NO CONTROLE DE TRATAMENTO SERIADO',
  '2505': 'O CÓDIGO COBRADO É DIFERENTE DO CÓDIGO AUTORIZADO',
  '2506': 'A QUANTIDADE DE SESSÕES COBRADAS É DIFERENTE DA QUANTIDADE AUTORIZADA',
  '2507': 'O CÓDIGO AUTORIZADO ESTÁ INCOMPATÍVEL COM A PRESCRIÇÃO MÉDICA SOLICITADA',
  '2508': 'COBRANÇA DE SESSÕES SEM O DEVIDO PLANO DE TRATAMENTO E, OU, COM O PRAZO DE PAGAMENTO EXPIRADO',
  '2509': 'COBRANÇA DO PROCEDIMENTO SERIADO INCOMPATÍVEL COM O QUADRO CLÍNICO',
  '2510': 'COBRANÇA DO PROCEDIMENTO SERIADO EM NÚMERO DE SESSÕES ACIMA DA QUANTIDADE ESTABELECIDA',
  '2511': 'AUSÊNCIA DE EVOLUÇÃO NO PRONTUÁRIO MÉDICO DO TRATAMENTO SERIADO REALIZADO',
  '2512': 'COBRANÇA DE SESSÕES DE FISIOTERAPIA EM DESACORDO COM AS EVOLUÇÕES DO PRONTUÁRIO MÉDICO',
  '2513': 'COBRANÇA DE TRATAMENTO SERIADO SEM JUSTIFICATIVA CLÍNICA/TÉCNICA',
  '2514': 'SERVIÇO NÃO CONTRATADO PARA O PRESTADOR',
  '2515': 'LOCAL DE ATENDIMENTO INADEQUADO',
  '2516': 'QUANTIDADE COBRADA DIFERENTE DA REALIZADA',
  '2601': 'CODIFICAÇÃO INCORRETA/INADEQUADA DO PROCEDIMENTO',
  '2602': 'COBRANÇA DE HONORÁRIO INCLUSO NO PROCEDIMENTO PRINCIPAL',
  '2603': 'COBRANÇA DE HONORÁRIO SEM REGISTRO DA EFETIVA PARTICIPAÇÃO DO PROFISSIONAL',
  '2604': 'PROCEDIMENTO PRINCIPAL NÃO REQUER EQUIPE MÉDICA',
  '2605': 'NÃO CABE PAGAMENTO DO HONORÁRIO INTEGRAL POR SER A MESMA VIA DE ACESSO CIRÚRGICO',
  '2606': 'COBRANÇA DO HONORÁRIO EM LOCAL DE ATENDIMENTO INCORRETO (INEXISTENTE)',
  '2607': 'COBRANÇA DE HONORÁRIOS EM DUPLICIDADE',
  '2608': 'COBRANÇA DE CONSULTA INDEVIDA, QUANDO O PROCEDIMENTO PRINCIPAL JÁ ESTÁ SENDO REMUNERADO',
  '2609': 'LOCAL DE ATENDIMENTO NÃO INFORMADO',
  '2610': 'GRAU DE PARTICIPAÇÃO DE AUXILIAR INCOMPATÍVEL COM PROCEDIMENTO COBRADO',
  '2611': 'COBRANÇA DE ESPECIALISTA NÃO JUSTIFICADA NO EVENTO',
  '2612': 'COBRANÇA INDEVIDA DE EQUIPE "STAND-BY", JÁ QUE ANGIOPLASTIA SEGUIDA DE CIRURGIA CARDÍACA',
  '2613': 'PROCEDIMENTO CIRÚRGICO, POIS "ANALGESIA POR DIA SUBSEQUENTE" COBRADA NA MESMA DATA DO EVENTO',
  '2614': 'COBRANÇA DE CADA PARTICIPANTE DA EQUIPE DEVE SER FEITA EM GUIAS DIFERENTES',
  '2702': 'COBRANÇA DE EXAME NÃO SOLICITADO PELO MÉDICO',
  '2703': 'EXAME SEM REGISTRO DE EXECUÇÃO',
  '2704': 'COBRANÇA DE EXAME NÃO CORRELACIONADO AO RELATÓRIO ESPECÍFICO',
  '2705': 'COBRANÇA DE PROCEDIMENTO/EXAME SEM JUSTIFICATIVA PARA REALIZAÇÃO OU COM JUSTIFICATIVA INSUFICIENTE',
  '2706': 'COBRANÇA DE PROCEDIMENTO/EXAME COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '2707': 'EXAME NÃO AUTORIZADO',
  '2708': 'COBRANÇA DE EXAME EM QUANTIDADE INCOMPATÍVEL COM O PROCEDIMENTO/EVOLUÇÃO CLÍNICA',
  '2710': 'COBRANÇA DE EXAME QUE EXIGE AUTORIZAÇÃO PRÉVIA',
  '2711': 'COBRANÇA DE EXAME COM HISTÓRIA CLÍNICA/HIPÓTESE DIAGNÓSTICA NÃO COMPATÍVEL',
  '2712': 'COBRANÇA DE EXAME EM QUANTIDADE ACIMA DA MÁXIMA PERMITIDA/AUTORIZADA',
  '2713': 'COBRANÇA DE EXAME NÃO COMPATÍVEL COM A IDADE',
  '2714': 'COBRANÇA DE EXAME COM AUSÊNCIA DE RESULTADO OU LAUDO TÉCNICO',
  '2715': 'ESPECIALIDADE, NO PRAZO INFERIOR AO ESTIPULADO SEM',
  '2716': 'EXAME COBRADO NÃO CORRESPONDE AO EXAME EXECUTADO',
  '2717': 'COBRANÇA DE EXAME AMBULATORIAL COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '2718': 'EXAMES NÃO JUSTIFICAM CARÁTER DE URGÊNCIA',
  '2801': 'PACOTE INVÁLIDO',
  '2802': 'PACOTE INCOMPATÍVEL COM O SEXO DO BENEFICIÁRIO',
  '2803': 'IDADE DO BENEFICIÁRIO INCOMPATÍVEL COM O PACOTE',
  '2804': 'VALOR TOTAL DO PACOTE DIFERENTE DO VALOR PROCESSADO',
  '2805': 'VALOR DO PACOTE SUPERIOR AO VALOR DOS ITENS',
  '2806': 'COBRANÇA DE PACOTE NÃO EXECUTADO',
  '2807': 'COBRANÇA DE PACOTE NÃO SOLICITADO PELO MÉDICO',
  '2808': 'PACOTE SEM REGISTRO DE EXECUÇÃO',
  '2809': 'COBRANÇA DE PACOTE NÃO CORRELACIONADO AO RELATÓRIO ESPECÍFICO',
  '2810': 'COBRANÇA DE PACOTE SEM JUSTIFICATIVA PARA REALIZAÇÃO OU COM JUSTIFICATIVA INSUFICIENTE',
  '2811': 'COBRANÇA DE PACOTE COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '2812': 'PACOTE NÃO AUTORIZADO',
  '2813': 'COBRANÇA DE PACOTE EM QUANTIDADE INCOMPATÍVEL COM O PROCEDIMENTO/EVOLUÇÃO CLÍNICA',
  '2814': 'ITENS DE COMPOSIÇÃO DO PACOTE NÃO REALIZADOS',
  '2815': 'COBRANÇA DO PACOTE EXIGE AUTORIZAÇÃO PRÉVIA',
  '2816': 'COBRANÇA DE PACOTE COM HISTÓRIA CLÍNICA/HIPÓTESE DIAGNÓSTICA NÃO COMPATÍVEL',
  '2817': 'COBRANÇA DE PACOTE EM QUANTIDADE ACIMA DA MÁXIMA PERMITIDA/AUTORIZADA',
  '2818': 'COBRANÇA DE PACOTE NÃO COMPATÍVEL COM A IDADE',
  '2819': 'COBRANÇA DE PACOTE COM AUSÊNCIA DE RESULTADO OU LAUDO TÉCNICO',
  '2820': 'ESPECIALIDADE, NO PRAZO INFERIOR AO ESTIPULADO SEM',
  '2821': 'PACOTE COBRADO NÃO CORRESPONDE AO EXAME EXECUTADO',
  '2822': 'COBRANÇA DE PACOTE AMBULATORIAL COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '2901': 'REVISÃO DE GLOSA INVÁLIDA',
  '2902': 'GLOSA MANTIDA',
  '2903': 'PEDIDO DE REVISÃO SEM JUSTIFICATIVA',
  '2904': 'MAIS DE UM RECURSO DE GLOSA PARA A MESMA GUIA/PROTOCOLO',
  '2905': 'A GUIA NÃO É DE REVISÃO',
  '2907': 'PRAZO DE 180 DIAS ULTRAPASSADO PARA SOLICITAÇÃO DE REANÁLISE',
  '2908': 'SOLICITAÇÃO DE REANÁLISE EFETUADA DE FORMA INCORRETA',
  '2909': 'PRAZO PARA SOLICITAÇÃO DE RECURSO DE GLOSA PRESCRITO',
  '3001': 'PROCEDIMENTO ODONTOLÓGICO INVÁLIDO',
  '3002': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO QUE EXIGE AUTORIZAÇÃO PRÉVIA',
  '3003': 'IDADE DO BENEFICIÁRIO INCOMPATÍVEL COM O PROCEDIMENTO ODONTOLÓGICO',
  '3004': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO EM QUANTIDADE ACIMA DA MÁXIMA PERMITIDA/AUTORIZADA',
  '3007': 'PROCEDIMENTOS ODONTOLÓGICOS DUPLICADOS',
  '3008': 'PROCEDIMENTO ODONTOLÓGICO INCLUSO NO PROCEDIMENTO PRINCIPAL',
  '3009': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO NÃO EXECUTADO',
  '3010': 'COBRANÇA DE PROCEDIMENTO NÃO SOLICITADO PELO CIRURGIÃO-DENTISTA',
  '3011': 'PROCEDIMENTO ODONTOLÓGICO SEM REGISTRO DE EXECUÇÃO',
  '3012': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO NÃO CORRELACIONADO AO RELATÓRIO ESPECÍFICO',
  '3013': 'JUSTIFICATIVA PARA REALIZAÇÃO OU COM JUSTIFICATIVA',
  '3014': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO COM DATA DE AUTORIZAÇÃO POSTERIOR À DO ATENDIMENTO',
  '3015': 'COBRANÇA DE PROCEDIMENTO ODONTOLÓGICO COM AUSÊNCIA DE RESULTADO OU LAUDO TÉCNICO',
  '3016': 'ESPECIALIDADE, NO PRAZO INFERIOR AO ESTIPULADO, SEM',
  '3017': 'PROCEDIMENTO COBRADO NÃO CORRESPONDE A PERÍCIA (ESPECIFICAR)',
  '3018': 'EVENTO GLOSADO POR AUDITORIA (ESPECIFICAR)',
  '3019': 'EVENTO SOB ANÁLISE TÉCNICA, AGUARDANDO LIBERAÇÃO DE CONFIRMAÇÃO PARA POSTERIOR PAGAMENTO',
  '3020': 'CONFORME DOCUMENTAÇÃO RADIOGRÁFICA ENVIADA, EVENTO REALIZADO INADEQUADAMENTE',
  '3021': 'FALHA EM INFORMAÇÃO DE DADOS DE ARCADAS/HEMI-ARCOS',
  '3022': 'FALHA EM INFORMAÇÃO DE DADOS DE DENTE INICIAL E/OU FINAL',
  '3023': 'FALHA EM INFORMAÇÃO DE DADOS DE FACES DOS DENTES',
  '3024': 'EVENTO SÓ POSSÍVEL EM DENTES DECÍDUOS',
  '3025': 'EVENTO SÓ POSSÍVEL EM DENTES PERMANENTES',
  '3026': 'ERRO NAS INFORMAÇÕES DE ORDEM DOS DENTES INICIAL E FINAL',
  '3027': 'DESACORDO ENTRE O TIPO DE DENTE E O NÚMERO DE CANAIS SOLICITADOS',
  '3028': 'EVENTO RESTRITO À ESPECIALISTAS',
  '3029': 'EVENTO NÃO INDICADO PELA AUDITORIA INICIAL',
  '3030': 'AUDITORIA FINAL CONSTA QUE A RESTAURAÇÃO FOI REALIZADA EM OUTRO MATERIAL',
  '3031': 'RADIOGRAFIA FORA DOS PADRÕES TÉCNICOS',
  '3032': 'INTERVALO DA ÚLTIMA MPP INFERIOR A TRÊS MESES',
  '3033': 'INTERVALO DA ÚLTIMA MPP INFERIOR A QUATRO MESES',
  '3034': 'JUSTIFICATIVA TECNICAMENTE NÃO SATISFATÓRIA',
  '3035': 'PACIENTE EM TRATAMENTO COM O MESMO PROFISSIONAL',
  '3036': 'PACIENTE EM TRATAMENTO COM OUTRO PROFISSIONAL',
  '3037': 'PROCEDIMENTO COBRADO NÃO É IGUAL AO EXECUTADO',
  '3038': 'RADIOGRAFIA INICIAL INCONGRUENTE COM A RADIOGRAFIA FINAL',
  '3039': 'RADIOGRAFIA NÃO CORRESPONDE AO PROCEDIMENTO COBRADO',
  '3040': 'GLOSA TÉCNICA (ESPECIFICAR DETALHADAMENTE)',
  '3041': 'AGUARDANDO DOCUMENTAÇÃO DE ORTODONTIA',
  '3042': 'APÓS ANÁLISE DA RADIOGRAFIA INICIAL VERIFICOU-SE EXODONTIA DE INCLUSO',
  '3043': 'APÓS ANÁLISE DA RADIOGRAFIA INICIAL VERIFICOU-SE EXODONTIA DE SEMI-INCLUSO',
  '3044': 'APÓS ANÁLISE DA RADIOGRAFIA INICIAL VERIFICOU-SE EXODONTIA SIMPLES',
  '3045': 'APÓS ANÁLISE DA RADIOGRAFIA INICIAL, VERIFICOU-SE EXODONTIA DE FRAGMENTO RADICULAR',
  '3046': 'AUDITORIA FINAL CONSTA QUE O PROCEDIMENTO FOI REALIZADO COM OUTRO MATERIAL',
  '3047': 'AUSÊNCIA DE IMAGEM/FOTO/RADIOGRAFIA/ DIAGNÓSTICO PÓS PROCEDIMENTO ODONTOLÓGICO',
  '3048': 'CANCELAMENTO DO PROCEDIMENTO ODONTOLÓGICO POR SOLICITAÇÃO DO BENEFICIÁRIO',
  '3049': 'CANCELAMENTO DO PROCEDIMENTO ODONTOLÓGICO POR SOLICITAÇÃO DO PRESTADOR',
  '3050': 'COBRANÇA DE URGÊNCIA/EMERGÊNCIA NA VIGÊNCIA DO TRATAMENTO ODONTOLÓGICO',
  '3051': 'DOCUMENTAÇÃO EM ANÁLISE',
  '3052': 'DOCUMENTAÇÃO INCOMPLETA, INCORRETA OU AUSENTE',
  '3053': 'ELEMENTOS PODEM SER VISUALIZADOS EM UMA MESMA PELÍCULA',
  '3054': 'IDENTIFICADO CONDUTO(S) NÃO OBTURADO(S)',
  '3055': 'IDENTIFICADO TRATAMENTO ENDODÔNTICO E NÃO RETRATAMENTO',
  '3056': 'NA AUDITORIA FOI CONSTATADA DIVERGÊNCIA NA QUANTIDADE DE FACES RESTAURADAS',
  '3057': 'NÃO APRESENTA A QUANTIDADE MÍNIMA DE ELEMENTOS DENTÁRIOS POR SEGMENTO',
  '3058': 'NECESSÁRIA AUDITORIA FINAL',
  '3059': 'NECESSÁRIA AUDITORIA INICIAL',
  '3060': 'NECESSÁRIA AUDITORIA INTERMEDIÁRIA',
  '3061': 'NECESSÁRIA AVALIAÇÃO DO ESPECIALISTA',
  '3062': 'NECESSÁRIO ENVIAR LAUDO OU RELATÓRIO TÉCNICO SOBRE O TRATAMENTO SOLICITADO',
  '3063': 'O PLANO DE TRATAMENTO AUTORIZADO SERÁ CANCELADO DEVIDO À TROCA DE PROFISSIONAL',
  '3064': 'PROCEDIMENTO AUTORIZADO APENAS PARA DENTES TRATADOS ENDODONTICAMENTE',
  '3065': 'PROCEDIMENTO AUTORIZADO SOMENTE PARA DENTES ANTERIORES',
  '3066': 'PROCEDIMENTO EM DESACORDO COM O ANEXO GUIA TRATAMENTO ODONTOLÓGICO SITUAÇÃO INICIAL',
  '3067': 'RADIOGRAFIA FINAL NÃO ENVIADA',
  '3068': 'RADIOGRAFIA FINAL SEM DISSOCIAÇÃO DOS CONDUTOS',
  '3069': 'RADIOGRAFIA INDICA A NECESSIDADE DE TRATAMENTO ENDODONTICO',
  '3070': 'RADIOGRAFIA INDICA A PRESENÇA DE RAIZ RESIDUAL NO ALVEOLO',
  '3071': 'RADIOGRAFIA INDICA AUSENCIA DE NÚCLEO',
  '3072': 'RADIOGRAFIA INDICA CANAL(AIS) NÃO OBTURADO(S)',
  '3073': 'RADIOGRAFIA INDICA DESVIO DA TRAJETORIA DO CANAL',
  '3074': 'RADIOGRAFIA INDICA EXCESSO DE MATERIAL',
  '3075': 'RADIOGRAFIA INDICA FALHA NA OBTURAÇÃO DO(S) CONDUTO(S)',
  '3076': 'RADIOGRAFIA INDICA FALTA DE ADAPTAÇÃO DA COROA/NÚCLEO',
  '3077': 'RADIOGRAFIA INDICA FALTA DE ADAPTAÇÃO DA COROA/PEÇA PROTÉTICA',
  '3078': 'RADIOGRAFIA INDICA NÚCLEO INADEQUADO',
  '3079': 'RADIOGRAFIA INDICA TRATAMENTO ENDODÔNTICO E NÃO RETRATATAMENTO ENDODÔNTICO',
  '3080': 'RADIOGRAFIA INICIAL E FINAL NÃO ENVIADAS',
  '3081': 'RADIOGRAFIA INICIAL NÃO ENVIADA',
  '3082': 'RADIOGRAFIA/IMAGEM INDICA FALHA NA RESTAURAÇÃO',
  '3083': 'REAVALIAR O PLANO DE TRATAMENTO OBSERVANDO CRITÉRIOS DE INDICAÇÃO, OPORTUNIDADE E VIABILIDADE',
  '3084': 'RELATÓRIO ANALISE TÉCNICA SEM CARIMBO/ASSINATURA DO PRESTADOR',
  '3085': 'RADIOGRAFIA NÃO CORRESPONDE AO PROCEDIMENTO SOLICITADO',
  '3086': 'TRATAMENTO ODONTOLÓGICO NÃO CARACTERIZADO COMO URGÊNCIA',
  '3087': 'COBRANÇA INDEVIDA DE TAXA ADMINISTRATIVA',
  '3088': 'VALOR ACATADO, CONFORME REAJUSTE RETROATIVO',
  '3089': 'QUANTIDADE DE ITENS INCOMPATÍVEL COM O PERÍODO DE INTERNAÇÃO',
  '3090': 'NECESSÁRIO ENVIAR AS ETIQUETAS E SELOS HEMOTERÁPICOS DO MATERIAL UTILIZADO',
  '3091': 'COBRANÇA FORA DO PRAZO ESTIPULADO NO CONTRATO',
  '3092': 'VALOR ACATADO POR GLOSA REALIZADA INDEVIDAMENTE, APÓS AVALIAÇÃO DO RECURSO',
  '3093': 'VALOR ACATADO POR AUTORIZAÇÃO ESPECIAL',
  '3094': 'VALOR DA TAXA ADMINISTRATIVA ALTERADO EM RAZÃO DE GLOSAS',
  '3095': 'RECURSO DE GLOSA ACATADO',
  '3096': 'ATENDIMENTO NÃO CONFIRMADO PELO BENEFICIÁRIO',
  '3097': 'TIPO DE ATENDIMENTO INCOMPATÍVEL COM A SEGMENTAÇÃO ASSISTENCIAL CONTRATADA',
  '3098': 'O PRESTADOR POSSUI PACOTE CONTRATADO PARA ESTE PROCEDIMENTO VERIFIQUE O CÓDIGO CORRESPONDENTE',
  '3100': 'OPERADORA E SOLICITE O CADASTRAMENTO DO SEU CÓDIGO DE',
  '3101': 'O PROCEDIMENTO SOLICITADO É DE EXECUÇÃO ÚNICA E JÁ FOI REALIZADO PELO BENEFICIÁRIO',
  '3102': 'É NECESSÁRIO TER UM PROCEDIMENTO RELACIONADO À SOLICITAÇÃO',
  '3103': 'SOLICITAÇÃO DE AUTORIZAÇÃO FORA DO PRAZO ACORDADO',
  '3104': 'RECUSADO, CONFORME JUNTA MÉDICA/ODONTOLÓGICA',
  '3105': 'ITEM COM UTILIZAÇÃO SUSPENSA PELO ÓRGÃO COMPETENTE',
  '3106': 'REGISTRO ANVISA INVÁLIDO OU NÃO INFORMADO',
  '3107': 'ITEM CATEGORIZADO COMO NÃO DESCARTÁVEL',
  '3108': 'ITEM INCLUSO NO PACOTE NEGOCIADO',
  '3109': 'CONSTAR DO ROL DE PROCEDIMENTOS E EVENTOS EM SAÚDE DA',
  '3110': 'BLOQUEIO JUDICIAL',
  '3111': 'CAMPO CONDICIONADO NÃO PREENCHIDO OU INCORRETO',
  '3112': 'DESCONTO DE COPARTICIPAÇÃO/FRANQUIA CONFORME CONTRATO',
  '3113': 'NECESSÁRIO ENVIO DE RADIOGRAFIA PERIAPICAL DA REGIÃO',
  '3114': 'NECESSÁRIO ENVIO DE RADIOGRAFIA INTERPROXIMAL DA REGIÃO',
  '3115': 'NECESSÁRIO ENVIO DE RADIOGRAFIA OCLUSAL DA REGIÃO',
  '3116': 'REALIZAÇÃO DE PROCEDIMENTO COM NECESSIDADE ESTÉTICA',
  '3117': 'PROCEDIMENTO ODONTOLÓGICO COM INDICAÇÃO TÉCNICA EM PROGNÓSTICO DESFAVORÁVEL',
  '3118': 'NECESSÁRIO ENVIAR TERMO DE CONSENTIMENTO INFORMADO',
  '3119': 'NECESSÁRIO ENVIAR TERMO DE RESPONSABILIDADE PROFISSIONAL',
  '3120': 'NECESSÁRIO O ENVIO DO PEDIDO DO PROFISSIONAL SOLICITANTE',
  '3121': 'ITEM AUTORIZADO E AINDA NÃO INDENIZADO',
  '3122': 'SOLICITAÇÃO DE REEMBOLSO EM PLANO SEM DIREITO À LIVRE ESCOLHA',
  '3123': 'ITEM PARA A MESMA FINALIDADE JÁ AUTORIZADO',
  '3124': 'RADIOGRAFIA SUGERE INDICAÇÃO DE EXODONTIA',
  '3125': 'RADIOGRAFIA SUGERE INDICAÇÃO DE RETRATAMENTO ENDODONTICO',
  '3126': 'COBRANÇA DE ITEM ANTERIOR À DATA DE REALIZAÇÃO',
  '3127': 'IMAGEM SUGERE ALTERAÇÃO PATOLÓGICA',
  '3128': 'IMAGEM SUGERE PRESENÇA DE ARTEFATO DE IMAGEM',
  '3129': 'IMAGEM SUGERE PRESENÇA DE CORPO ESTRANHO',
  '3130': 'IMAGEM SUGERE IMPLANTE EM PROCESSO DE OSSEOINTEGRAÇÃO',
  '3131': 'ENVIAR PLANO DE TRATAMENTO ORTODÔNTICO INICIAL',
  '3132': 'ENVIAR PLANO DE TRATAMENTO ORTODÔNTICO INTERMEDIÁRIO',
  '3133': 'TRATAMENTO ORTODÔNTICO CONCLUÍDO',
  '3134': 'TRATAMENTO ORTODÔNTICO EM FASE DE CONTENÇÃO',
  '3135': 'PROFISSIONAL INFORMADO PARA REEMBOLSO PERTENCE A REDE DA OPERADORA',
  '3136': 'PROCEDIMENTO OU ITEM ASSISTENCIAL AUTORIZADO',
  '3137': 'PROCEDIMENTO PREVÊ COPARTICIPAÇÃO/FRANQUIA CONFORME CONTRATO',
  '3138': 'CONDIÇÃO CLÍNICA INCOMPATÍVEL COM A SOLICITAÇÃO',
  '3139': 'TRATAMENTO ORTODONTICO SUSPENSO A PEDIDO DO DENTISTA',
  '3140': 'ABANDONO DE TRATAMENTO PELO BENEFICIÁRIO',
  '3141': 'BENEFICIÁRIO NÃO POSSUI COBERTURA PARA ASSISTÊNCIA AMBULATORIAL',
  '3142': 'ITEM NÃO CONTRATADO',
  '3143': 'VALOR ACATADO POR DECISÃO JUDICIAL /LIMINAR',
  '3144': 'NÃO É NECESSÁRIA AUTORIZAÇÃO PRÉVIA',
  '3145': 'NÃO AUTORIZADO POR MOTIVO TÉCNICO',
  '3146': 'PRODUTO CONTRATADO NÃO ADAPTADO À LEI 9656/98, SEM COBERTURA CONTRATUAL PARA O ITEM SOLICITADO',
  '3147': 'MATERIAL PASSÍVEL DE REPROCESSAMENTO',
  '3148': 'TIPO DE TRANSAÇÃO INVÁLIDO',
  '3149': 'INDICADOR DE ENVIO EM PAPEL INVÁLIDO',
  '3150': 'CÓDIGO DA TABELA INVÁLIDO',
  '3151': 'INFORMAÇÃO SOBRE PARTOS NÃO POSSUÍA VÍNCULO COM A',
  '3152': 'SOBRE PARTOS NÃO POSSUÍA VÍNCULO COM A OPERADORA NO',
  '3153': 'INFORMAÇÃO SOBRE PARTOS NÃO POSSUI VÍNCULO COM A',
  '3154': 'O PROFISSIONAL PARA O QUAL FOI SOLICITADA A INFORMAÇÃO SOBRE PARTOS NÃO POSSUI VÍNCULO COM A OPERADORA',
  '3155': 'PARTOGRAMA OU RELATÓRIO MÉDICO NÃO DISPONÍVEL PARA CONSULTA DA OPERADORA',
  '3156': 'TOKEN INVÁLIDO',
  '3157': 'QR CODE INVÁLIDO',
  '3158': 'BIOMETRIA – FALHA NA TRANSMISSÃO',
  '3159': 'BIOMETRIA – NÃO COMPATÍVEL',
  '3160': 'TIME OUT - TENTE NOVAMENTE',
  '3161': 'PRAZO DE ENVIO FORA DO PERÍODO CONTRATUAL ACORDADO ENTRE AS PARTES',
  '3162': 'CÓDIGO DO PROTOCOLO NÃO ENCONTRADO',
  '3163': 'NÃO NECESSITA DE IMAGEM',
  '3164': 'ARQUIVO ENVIADO NÃO É DE IMAGEM',
  '3165': 'ARQUIVO DE IMAGEM CORROMPIDO',
  '3166': 'ARQUIVO ENVIADO EXCEDE O TAMANHO MÁXIMO PERMITIDO',
  '3167': 'SEQUENCIAL INVÁLIDO',
  '3168': 'ASSINATURA DIGITAL INVÁLIDA OU NÃO ENVIADA',
  '5001': 'MENSAGEM ELETRÔNICA FORA DO PADRÃO TISS',
  '5002': 'NÃO FOI POSSÍVEL VALIDAR O ARQUIVO XML',
  '5003': 'ENDEREÇO DO REMETENTE INVÁLIDO',
  '5004': 'ENDEREÇO DO DESTINATÁRIO INVÁLIDO',
  '5005': 'REMETENTE NÃO IDENTIFICADO',
  '5006': 'DESTINATÁRIO NÃO IDENTIFICADO',
  '5007': 'MENSAGEM INCONSISTENTE OU INCOMPLETA',
  '5008': 'ESPAÇO RESERVADO PARA A CAIXA DE SAÍDA INSUFICIENTE',
  '5009': 'ESPAÇO RESERVADO PARA A CAIXA DE ENTRADA INSUFICIENTE',
  '5010': 'ENVIO DE MENSAGEM NÃO FOI TERMINADO',
  '5011': 'ENVIO DE MENSAGEM FINALIZADA',
  '5012': 'RECEBIMENTO DE MENSAGEM NÃO FINALIZADO',
  '5013': 'RECEBIMENTO DE MENSAGEM FINALIZADA',
  '5014': 'CÓDIGO HASH INVÁLIDO MENSAGEM PODE ESTAR CORROMPIDA',
  '5015': 'NÚMERO DE GUIAS/DEMONSTRATIVOS DENTRO DA MENSAGEM SUPERIOR AO TAMANHO MÁXIMO PERMITIDO',
  '5016': 'SEM NENHUMA OCORRENCIA DE MOVIMENTO NA COMPETENCIA PARA ENVIO A ANS',
  '5017': 'ARQUIVO PROCESSADO PELA ANS',
  '5018': 'CERTIFICADO DIGITAL INVÁLIDO',
  '5019': 'CERTIFICADO DIGITAL VENCIDO',
  '5020': 'CERTIFICADO DIGITAL REVOGADO',
  '5021': 'CADEIA DE CERTIFICAÇÃO INVÁLIDA',
  '5022': 'ASSINATURA DIGITAL NÃO CONFERE',
  '5023': 'COMPETÊNCIA NÃO ESTÁ LIBERADA PARA ENVIO DE DADOS',
  '5024': 'OPERADORA INATIVA NA COMPETÊNCIA DOS DADOS',
  '5025': 'DATA DE REGISTRO DA TRANSAÇÃO INVÁLIDA',
  '5026': 'HORA DE REGISTRO DA TRANSAÇÃO INVÁLIDA',
  '5027': 'REGISTRO ANS DA OPERADORA INVÁLIDO',
  '5028': 'VERSÃO DO PADRÃO INVÁLIDA',
  '5029': 'INDICADOR INVÁLIDO',
  '5030': 'CÓDIGO DO MUNÍCIPIO INVÁLIDO',
  '5031': 'CARÁTER DE ATENDIMENTO INVÁLIDO',
  '5032': 'INDICADOR DE RECÉM-NATO INVÁLIDO',
  '5033': 'MOTIVO DE ENCERRAMENTO INVÁLIDO',
  '5034': 'VALOR NÃO INFORMADO',
  '5035': 'CÓDIGO DA TABELA DE REFERÊNCIA NÃO INFORMADO',
  '5036': 'CÓDIGO DO GRUPO DO PROCEDIMENTO INVÁLIDO',
  '5037': 'CÓDIGO DO DENTE INVÁLIDO',
  '5038': 'CÓDIGO DA REGIÃO DA BOCA INVÁLIDO',
  '5039': 'CÓDIGO DA FACE DO DENTE INVÁLIDO',
  '5040': 'VALOR DEVE SER MAIOR QUE ZERO',
  '5041': 'QUANTIDADE NÃO INFORMADA',
  '5042': 'VALOR INFORMADO DA GUIA DIFERENTE DO SOMATÓRIO DO VALOR INFORMADO DOS ITENS',
  '5043': 'MOTIVO INVÁLIDO',
  '5044': 'JÁ EXISTEM INFORMAÇÕES NA ANS PARA A COMPETÊNCIA INFORMADA',
  '5045': 'COMPETÊNCIA ANTERIOR NÃO ENVIADA',
  '5046': 'COMPETÊNCIA INVÁLIDA',
  '5047': 'NÚMERO DO LOTE NÃO INFORMADO',
  '5048': 'DATA DE NASCIMENTO DO BENEFICIÁRIO INVÁLIDA',
  '5049': 'VALOR TOTAL MENOR QUE ZERO NA GUIA',
  '5050': 'VALOR INFORMADO INVÁLIDO',
  '5051': 'COMPETENCIA DO ARQUIVO DIFERENTE DA COMPETENCIA DA DATA DE PROCESSAMENTO DO LANÇAMENTO',
  '5052': 'IDENTIFICADOR INEXISTENTE',
  '5053': 'IDENTIFICADOR JÁ INFORMADO',
  '5054': 'IDENTIFICADOR NÃO ENCONTRADO',
  '5055': 'IDENTIFICADOR JÁ INFORMADO NA COMPETÊNCIA',
  '5056': 'IDENTIFICADOR NÃO INFORMADO NA COMPETÊNCIA',
  '5057': 'GUIA DE CONSULTA COM MAIS DE UM PROCEDIMENTO',
  '5058': 'PROCEDIMENTO INCOMPATÍVEL COM O TIPO DE GUIA',
  '5059': 'EXCLUSÃO INVÁLIDA - EXISTEM LANÇAMENTOS VINCULADOS A ESTA FORMA DE CONTRATAÇÃO',
  '5060': 'VALOR TOTAL PAGO DIFERENTE DA SOMA DAS PARCELAS PAGAS NO LANÇAMENTO',
  '5061': 'TIPO DE ATENDIMENTO OPERADORA INTERMEDIÁRIA NÃO INFORMADO',
  '5062': 'REGISTRO ANS DA OPERADORA INTERMEDIÁRIA NÃO INFORMADO',
  '5063': 'PAR CNPJ x CNES NAO ENCONTRADO NA BASE DO CNES',
  '5064': 'TIPO DE ESTABELECIMENTO NO CNES NÃO É APTO PARA INTERNAÇÃO',
  '5065': 'TIPO DE ATIVIDADE ECONOMICA DO CNPJ NÃO É APTO PARA INTERNAÇÃO',
  '5066': 'NÚMERO DA DECLARAÇÃO EM DUPLICIDADE.',
  '5067': 'DIAGNÓSTICO EM DUPLICIDADE',
  '5068': 'DECLARAÇÃO DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5069': 'CÓDIGO DO DENTE DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5070': 'CÓDIGO DA REGIÃO DA BOCA DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5071': 'CÓDIGO DA FACE DO DENTE DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5072': 'VALOR INFORMADO DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5073': 'O PRIMEIRO LANCAMENTO DA GUIA SÓ PODE SER EXCLUIDO SE ELE FOR O ÚNICO',
  '5074': 'REGIME DE ATENDIMENTO INVÁLIDO',
  '5075': 'CID DIFERENTE DO LANÇAMENTO ANTERIOR DA GUIA',
  '5076': 'CPF NÃO ENCONTRADO NA RECEITA FEDERAL',
  '5077': 'SEXO NA RECEITA FEDERAL DIFERENTE DO INFORMADO PARA O CPF',
  '5078': 'DATA DE NASCIMENTO NA RECEITA FEDERAL DIFERENTE DA INFORMADA PARA O CPF',
  '5079': 'MODELO DE REMUNERAÇÃO EM DUPLICIDADE.',
  '5080': 'MODELO DE REMUNERAÇÃO NÃO INFORMADO',
  '5081': 'MODELO DE REMUNERAÇÃO NÃO DEVE SER INFORMADO PARA REEMBOLSO/PRESTADOR EVENTUAL',
  '5082': 'MODELO DE REMUNERAÇÃO NÃO DEVE SER INFORMADO PARA REDE PROPRIA COM MESMO CNPJ',
  '5083': 'SOMA DOS VALORES DOS MODELOS DE REMUNERAÇÃO DIFERENTE DO VALOR INFORMADO DA GUIA',
  '5084': 'UNIDADE DE MEDIDA NÃO DEVE SER PREENCHIDA PARA A TABELA TUSS INFORMADA',
  '5085': 'UNIDADE DE MEDIDA É OBRIGATÓRIA PARA A TABELA TUSS INFORMADA',
  '5086': 'DADO DIVERGENTE COM A RECEITA FEDERAL PARA ESTE CNS (CPF/SEXO/DATA NASCIMENTO)',
};

// Descreve um codigo de glosa. Retorna null quando o codigo nao esta na tabela oficial
// (nesse caso o chamador deve mostrar so o numero, em vez de inventar um significado).
export function descreverGlosa(codigo) {
  if (codigo === null || codigo === undefined || codigo === '') return null;
  return GLOSAS_TISS[String(codigo).trim()] || null;
}

// Formata para exibicao: "1427 - NECESSIDADE DE AUDITORIA MEDICA" ou "Glosa 9999" se desconhecido.
export function formatarGlosa(codigo, { prefixo = '' } = {}) {
  if (codigo === null || codigo === undefined || codigo === '') return '';
  const cod = String(codigo).trim();
  const desc = descreverGlosa(cod);
  return desc ? `${prefixo}${cod} - ${desc}` : `${prefixo}${cod}`;
}
